module.exports = __webpack_public_path__ + "static/media/shell.c14d490a.png";